// Converte as colunas do catálogo no formato que o useExport já espera
// ({ columns, headers }) — o hook não muda por causa do relatório.
export function montarExportOptions(colunas) {
    const lista = Array.isArray(colunas) ? colunas.filter(Boolean) : []

    const columns = lista.map(coluna => coluna.nome).filter(Boolean)

    const headers = {}
    lista.forEach(coluna => {
        if (coluna.nome) {
            headers[coluna.nome] = coluna.label || coluna.nome
        }
    })

    return { columns, headers }
}
